import { siteInfo } from '@/mocks/home';

export default function HeroSection() {
  const handleScrollTo = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const target = document.querySelector(href);
    if (target) {
      target.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[700px] flex items-center pt-[72px] overflow-hidden bg-background-50"
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-12 xl:gap-16 max-w-[1280px] mx-auto">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-accent-100/80 text-accent-700 text-xs font-medium mb-4 md:mb-5">
              <span className="w-1.5 h-1.5 rounded-full bg-accent-500"></span>
              {siteInfo.tagline}
            </div>

            <h1 className="text-2xl md:text-4xl lg:text-5xl font-bold font-heading text-foreground-950 leading-tight mb-3 md:mb-4">
              蚂蚁影视 · 高清免费在线观影平台
            </h1>

            <p className="text-lg md:text-xl text-foreground-600 font-heading mb-5 md:mb-6">
              {siteInfo.slogan}
            </p>

            <p className="text-sm md:text-base text-foreground-600 leading-relaxed max-w-xl mx-auto lg:mx-0 mb-6 md:mb-8">
              {siteInfo.description}
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-4 md:gap-6 mb-6 md:mb-8">
              {siteInfo.heroStats.map((stat) => (
                <div key={stat.label} className="text-center">
                  <div className="text-xl md:text-2xl font-bold text-foreground-900 font-heading">
                    {stat.value}
                  </div>
                  <div className="text-xs text-foreground-500 mt-1">{stat.label}</div>
                </div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#cards"
                onClick={(e) => handleScrollTo(e, '#cards')}
                className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-6 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 text-sm md:text-base font-medium rounded-lg transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-play-circle-line text-lg"></i>
                立即观影
              </a>
              <a
                href="#features"
                onClick={(e) => handleScrollTo(e, '#features')}
                className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-6 py-3 border border-background-300 hover:border-primary-300 hover:bg-primary-50/60 text-foreground-700 hover:text-primary-700 text-sm md:text-base font-medium rounded-lg transition-all whitespace-nowrap cursor-pointer"
              >
                <i className="ri-information-line text-lg"></i>
                了解详情
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-[520px] lg:max-w-none">
            <div className="relative rounded-2xl overflow-hidden aspect-[4/3] lg:aspect-[5/4]">
              <img
                src="https://readdy.ai/api/search-image?query=cinematic%20film%20projector%20beam%20of%20warm%20golden%20light%20shining%20through%20darkness%20film%20reel%20and%20clapperboard%20abstract%20artistic%20composition%20warm%20amber%20and%20coral%20tones%20dramatic%20cinematic%20atmosphere%20professional%20photography%20depth%20of%20field&width=1040&height=780&seq=hero-visual&orientation=landscape"
                alt="蚂蚁影视 - 高清免费在线观影平台"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent"></div>
              <div className="absolute bottom-4 left-4 right-4 flex items-center gap-2">
                <div className="flex items-center gap-1.5 bg-background-50/90 backdrop-blur-sm rounded-full px-3 py-1.5">
                  <span className="w-2 h-2 rounded-full bg-accent-500"></span>
                  <span className="text-xs font-medium text-foreground-900">正在热播</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}